import { ENV } from "../utils";

export class Responsible {
  baseApi = ENV.BASE_API;

  async getResponsibles(accessToken, active = true) {
    const url = `${this.baseApi}/responsibles?active=${active}`;
    const response = await fetch(url, { headers: { Authorization: `Bearer ${accessToken}` } });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async createResponsible(accessToken, data) {
    const response = await fetch(`${this.baseApi}/add-responsible`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async updateResponsible(accessToken, id, data) {
    const response = await fetch(`${this.baseApi}/update-responsible/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async deleteResponsible(accessToken, id) {
    const response = await fetch(`${this.baseApi}/delete-responsible/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
